class TabbedCollapsibleTabs {
  constructor(section) {
    this.section = section;
    this.tabButtons = this.section.querySelectorAll('.tab-navigation__item');
    this.tabContents = this.section.querySelectorAll('.tab-content');
    
    this.init();
  }
  
  init() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => this.switchTab(e));
    });
    
    this.section.querySelector('.tab-navigation__wrapper').addEventListener('keydown', (e) => {
      this.handleKeyboard(e);
    });
  }
  
  switchTab(e) {
    const button = e.currentTarget;
    const tabId = button.dataset.tab;
    
    this.tabButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    
    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    
    this.tabContents.forEach(content => {
      content.classList.remove('active');
      content.setAttribute('aria-hidden', 'true');
    });
    
    const targetContent = document.getElementById(tabId);
    if (targetContent) {
      targetContent.classList.add('active');
      targetContent.setAttribute('aria-hidden', 'false');
      
      const accordions = targetContent.querySelectorAll('details[open]');
      accordions.forEach(accordion => {
        accordion.removeAttribute('open');
      });
    }
  }
  
  handleKeyboard(e) {
    const currentButton = document.activeElement;
    if (!currentButton.classList.contains('tab-navigation__item')) return;
    
    const buttonsArray = Array.from(this.tabButtons);
    const currentIndex = buttonsArray.indexOf(currentButton);
    
    let nextIndex;
    
    switch(e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        nextIndex = currentIndex > 0 ? currentIndex - 1 : buttonsArray.length - 1;
        break;
      case 'ArrowRight':
        e.preventDefault();
        nextIndex = currentIndex < buttonsArray.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'Home':
        e.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        nextIndex = buttonsArray.length - 1;
        break;
      default:
        return;
    }
    
    if (nextIndex !== undefined) {
      buttonsArray[nextIndex].focus();
      buttonsArray[nextIndex].click();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section--tabbed-collapsible-tabs');
  sections.forEach(section => {
    new TabbedCollapsibleTabs(section);
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.section--tabbed-collapsible-tabs');
  if (section) {
    new TabbedCollapsibleTabs(section);
  }
});